export default __webpack_public_path__ + "static/vadym-boyarchuk-cf80ac08ee2c159b424b114e78e49926.png";